import React, { useCallback, FC } from 'react';
import { IoMdClose } from 'react-icons/io';
import { Box } from 'common/box';
import { Drawer } from 'common/drawer';
import { MenuIcon, LogoutIcon, BackIcon, VehicleIcon } from 'common/icons';
import LogoImg from 'assets/logo.png';
import { useAuthState } from 'state/auth';
import { RoutesSettings } from 'config/index';
import { useNavigate } from 'react-router';
import { useHeaderDrawerDispatch, useHeaderDrawerState } from './header-drawer.context';

import styles from './mobile-drawer.module.scss';

export const MobileDrawer: FC<{ isBackBehaviorEnable?: boolean }> = ({ isBackBehaviorEnable }) => {
  const navigate = useNavigate();
  const dispatch = useHeaderDrawerDispatch();
  const { isOpen } = useHeaderDrawerState();
  const { onLogout, user: userInfo } = useAuthState();

  const onSignOut = useCallback(() => {
    onLogout();
    navigate(RoutesSettings.signIn, { replace: true });
  }, []);

  // Toggle drawer
  const toggleHandler = React.useCallback(() => {
    if (isBackBehaviorEnable) {
      navigate(-1);
      return;
    }

    dispatch({
      type: 'TOGGLE',
    });
  }, [isBackBehaviorEnable]);

  return (
    <Drawer
      closeButton={<IoMdClose color="#000000" size="24px" />}
      closeButtonContainerClassName={styles.closeButton}
      drawerClassName={styles.drawer}
      drawerHandler={<Box className={styles.handler}>{isBackBehaviorEnable ? <BackIcon /> : <MenuIcon />}</Box>}
      open={isOpen}
      toggleHandler={toggleHandler}
      width="320px">
      <Box className={styles.content}>
        <img alt="logo" className={styles.headerLogo} src={LogoImg} />
        <div className="pt-4 text-center">
          <p>{userInfo?.fullName}</p>
          <p>{userInfo?.rut || '-'}</p>
        </div>
        <ul className={styles.menuContainer}>
          <li onClick={() => navigate(RoutesSettings.home, { replace: true })}>
            <VehicleIcon size={19} /> <span>MIS VEHICULOS</span>
          </li>
          <li onClick={onSignOut}>
            <LogoutIcon /> <span>CERRAR SESIÓN</span>
          </li>
        </ul>
      </Box>
    </Drawer>
  );
};

export default MobileDrawer;
